import React, { FC, useMemo, useState } from 'react';
import styles from './index.module.scss';
import {
  V2MicrogridOverviewGetBsaTodayInfoPostResponse,
  V2MicrogridOverviewGetNewEnergyExistsPostResponse,
  V2MicrogridOverviewGetNewEnergyRatePostResponse,
} from '@maxtropy/intelligent-dispath-apis-v2';
import DataBox from '../DataBox';
import icon_small_ground from '../../../../../imgs/icon-small-ground.png';
import icon_energyStorage from '../../../../../imgs/icon-energyStorage.png';
import { formatPower, judgeOverZero, keepTwoAbsOrLine, keepTwoOrLine } from '@/pages/IndustrialGreenMicBigScreen/utils';
import icon_pv from '../../../../../imgs/icon-PV.png';
import icon_windTurbine from '../../../../../imgs/icon-windTurbine.png';
import TwoAssetsRender from '../TwoAssetsRender';
import BsaDataBox from '../BsaDataBox';

type Energy = {
  [key: string]: boolean;
};

export interface IFourAssetsRender {
  dataExit?: V2MicrogridOverviewGetNewEnergyExistsPostResponse;
  data?: V2MicrogridOverviewGetNewEnergyRatePostResponse;
}

const FourAssetsRender: FC<IFourAssetsRender> = props => {
  const { dataExit, data } = props;
  const [bsaData, setBsaData] = useState<V2MicrogridOverviewGetBsaTodayInfoPostResponse>();

  const name = useMemo(() => {
    const obj: Energy = {
      光伏: dataExit?.pvExists ?? false,
      风电: dataExit?.wpExists ?? false,
    };
    const trueKeys = Object.keys(obj).filter(key => obj[key]);
    return trueKeys[0];
  }, [dataExit]);

  return (
    <>
      {/* 固定市电和负载 */}
      <TwoAssetsRender data={data} />

      {dataExit?.bsaExists ? (
        <>
          <DataBox
            top={82}
            left={5}
            leftTitle={'源'}
            data={
              name === '光伏'
                ? [
                    {
                      label: '光伏容量',
                      value: keepTwoOrLine(data?.pvInfo?.capacity),
                      unit: 'kW',
                      color: 'rgba(255,255,255,0.85)',
                    },
                    {
                      label: '今日发电量',
                      value: formatPower(data?.pvInfo?.todayGeneration).value,
                      unit: formatPower(data?.pvInfo?.todayGeneration).unit,
                      color: '#16DD8E',
                    },
                  ]
                : [
                    {
                      label: '风电站容量',
                      value: keepTwoOrLine(data?.wpInfo?.capacity),
                      unit: 'kW',
                      color: 'rgba(255,255,255,0.85)',
                    },
                    {
                      label: '今日发电量',
                      value: formatPower(data?.wpInfo?.todayGeneration).value,
                      unit: formatPower(data?.wpInfo?.todayGeneration).unit,
                      color: '#16DD8E',
                    },
                  ]
            }
          />
          {/* 其余3 */}
          <div className={`${styles.element3} ${styles.element}`}>
            <img className={styles.img_obj_sty} src={name === '光伏' ? icon_pv : icon_windTurbine} alt="" />
            <img className={`${styles.img_normal_sty} `} src={icon_small_ground} alt="" />
            <div className={styles.label}>{name}</div>
          </div>
          {/* 流动的线3 */}
          <div className={`${styles.lineBg3} ${styles.lineBg_normal}`}>
            {/* 线上面数据 */}
            <div className={styles.line_data}>
              <div className={styles.label}>发电功率：</div>
              <div className={styles.value}>
                {name === '光伏'
                  ? keepTwoOrLine(data?.pvInfo?.generationPower)
                  : keepTwoOrLine(data?.wpInfo?.generationPower)}
                kW
              </div>
            </div>
            <div className={`${styles.line_inside_normal} ${styles.line3} ${styles.flow_left}`}></div>
          </div>

          {/* 储能4 */}
          <BsaDataBox dataExit={dataExit} top={82} left={76} leftTitle="储" getBsaData={val => setBsaData(val)} />
          <div className={`${styles.element4} ${styles.element}`}>
            <img className={styles.img_obj_sty} src={icon_energyStorage} alt="" />
            <img className={`${styles.img_normal_sty} `} src={icon_small_ground} alt="" />
            <div className={styles.label}>储能</div>
          </div>
          {/* 流动的线4 */}
          <div className={`${styles.lineBg4} ${styles.lineBg_normal}`}>
            {/* 线上面数据 */}
            <div className={styles.line_data}>
              <div className={styles.label}>{judgeOverZero(bsaData?.power) ? '充电' : '放电'}功率：</div>
              <div className={styles.value}>{keepTwoAbsOrLine(bsaData?.power)}kW</div>
            </div>
            <div
              className={`${styles.line_inside_normal} ${styles.line4} ${
                styles[judgeOverZero(bsaData?.power) ? 'flow_left' : 'flow_right']
              }`}
            ></div>
          </div>
        </>
      ) : (
        <>
          {/* 其余3 */}
          <DataBox
            top={82}
            left={5}
            leftTitle={'源'}
            data={[
              {
                label: '光伏容量',
                value: keepTwoOrLine(data?.pvInfo?.capacity),
                unit: 'kW',
                color: 'rgba(255,255,255,0.85)',
              },
              {
                label: '今日发电量',
                value: formatPower(data?.pvInfo?.todayGeneration).value,
                unit: formatPower(data?.pvInfo?.todayGeneration).unit,
                color: '#16DD8E',
              },
            ]}
          />
          <div className={`${styles.element3} ${styles.element}`}>
            <img className={styles.img_obj_sty} src={icon_pv} alt="" />
            <img className={`${styles.img_normal_sty} `} src={icon_small_ground} alt="" />
            <div className={styles.label}>{'光伏'}</div>
          </div>
          {/* 流动的线3 */}
          <div className={`${styles.lineBg3} ${styles.lineBg_normal}`}>
            {/* 线上面数据 */}
            <div className={styles.line_data}>
              <div className={styles.label}>发电功率：</div>
              <div className={styles.value}>
                {keepTwoOrLine(data?.pvInfo?.generationPower)}
                kW
              </div>
            </div>
            <div className={`${styles.line_inside_normal} ${styles.line3} ${styles.flow_left}`}></div>
          </div>

          {/* 其余4 */}
          <DataBox
            top={82}
            left={76}
            leftTitle={'源'}
            data={[
              {
                label: '风电站容量',
                value: keepTwoOrLine(data?.wpInfo?.capacity),
                unit: 'kW',
                color: 'rgba(255,255,255,0.85)',
              },
              {
                label: '今日发电量',
                value: formatPower(data?.wpInfo?.todayGeneration).value,
                unit: formatPower(data?.wpInfo?.todayGeneration).unit,
                color: '#16DD8E',
              },
            ]}
          />
          <div className={`${styles.element4} ${styles.element}`}>
            <img className={styles.img_obj_sty} src={icon_windTurbine} alt="" />
            <img className={`${styles.img_normal_sty} `} src={icon_small_ground} alt="" />
            <div className={styles.label}>{'风电'}</div>
          </div>
          {/* 流动的线4 */}
          <div className={`${styles.lineBg4} ${styles.lineBg_normal}`}>
            {/* 线上面数据 */}
            <div className={styles.line_data}>
              <div className={styles.label}>发电功率：</div>
              <div className={styles.value}>
                {keepTwoOrLine(data?.wpInfo?.generationPower)}
                kW
              </div>
            </div>
            <div className={`${styles.line_inside_normal} ${styles.line4} ${styles.flow_right}`}></div>
          </div>
        </>
      )}
    </>
  );
};

export default FourAssetsRender;
